/* eslint-disable no-unused-vars */

// Expose Backbone UnderscoreJS
import _ from 'underscore';

import $ from 'jquery';
import Backbone from 'backbone';
import Clipboard from 'clipboard';
import CryptoJS from 'crypto-js/core';

// Views
import CouponsPageItem from '@legacy-js/views/coupons_page_item';

// Models
import Deal from '@legacy-js/models/deal';

// Controllers
import ApplicationController from '@legacy-js/controllers/application_controller';
import CookiesController from '@legacy-js/controllers/cookies_controller';
import FacebookPixelController from '@legacy-js/controllers/facebook_pixel_controller';
import TrackingController from '@legacy-js/controllers/tracking_controller';
import SegmentController from '@legacy-js/controllers/segment_controller';
import MobileDevicesController from '@legacy-js/controllers/mobile_devices_controller';
import ModalsController from '@legacy-js/controllers/modals_controller';
import NavigationController from '@legacy-js/controllers/navigation_controller';
import CouponModalsController from '@legacy-js/controllers/coupon_modals_controller';
import UserApplicationController from '@legacy-js/controllers/user_application_controller';

// Singletons
import Facebook from '@legacy-js/lib/facebook';
import Forms from '@legacy-js/lib/forms/forms';
import FuzzyTime from '@legacy-js/lib/fuzzy_time';
import GoLinks from '@legacy-js/lib/go_links';
import Google from '@legacy-js/lib/google';
import Scrolling from '@legacy-js/lib/scrolling';
import BdUser from '@src-js/app/bd_user';
import sst from '@vendor-js/sst';
import Segment from '@src-js/utils/segment';

// View Helpers
import * as ViewHelpers from '@legacy-js/lib/view_helpers';

// Core
import Base from '@src-js/app/base';
import Assets from '@src-js/app/assets.js.erb';

window.sst = sst;
window.Segment = new Segment();

/** Setup Peformance Listeners */
require('@src-js/utils/performance-metrics');

/** jQuery Plugins */
require('jquery-validation');
require('jquery-ujs');

/** Exteand Backbone Sync function with Rails headers and more */
require('@vendor-js/backbone_rails_sync');

/** Import specific cryptographic libraries */
require('crypto-js/sha1');
require('crypto-js/md5');
require('crypto-js/sha256');

/** Auto completer library */
require('@vendor-js/autocompleter');

window.App = {
  Assets,
  Controllers: {
    ApplicationController,
    CookiesController,
    FacebookPixelController,
    TrackingController,
    SegmentController,
    MobileDevicesController,
    ModalsController,
    NavigationController,
    CouponModalsController,
    UserApplicationController,
  },
  FB: Facebook,
  GoLinks,
  Google,
  Models: {
    Deal,
  },
  Scrolling,
  Views: {
    CouponsPageItem,
  },
  ViewHelpers,
  ...Base,
};

// Initialize App Singletons
Forms.initialize();
FuzzyTime.initialize(window.App);
GoLinks.initialize();
Facebook.initialize(window.App);
Google.initialize(window.App);
Scrolling.initialize(window.App);

window.$(App.initialize);

// Initialize Controllers
Object.values(window.App.Controllers).forEach((c) => c.initialize());

// Asynchronously load Vue, Vue Carousel, and this component ONLY when needed
window.App.Dispatcher.on('initDealCarouselWidget', (options) => {
  import('./deal_carousel_widget')
    .then(({ initDealCarouselWidget }) => {
      initDealCarouselWidget(options);
    })
    .catch((e) => console.error(e));
});
